const TEMP_EMAIL_SUFFIX = "@pending.school.local";

export const isTemporaryTeacherEmail = (email) =>
    String(email || "")
        .trim()
        .toLowerCase()
        .endsWith(TEMP_EMAIL_SUFFIX);

export const teacherNeedsOnboarding = (user) => {
    if (!user || user.role !== "Teacher") return false;
    return Boolean(!user.profileCompleted || user.emailIsTemporary || isTemporaryTeacherEmail(user.email));
};
